module.exports = __webpack_public_path__ + "img/order-follower-img.14c808ec.svg";